export default "https://cdn-static.gokick.com/assets/3bfc31eca91a3170017daa7173a338c2b0e2dfbc/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";